// extracted by mini-css-extract-plugin
export const arrowButton = "ArrowButton-module--arrow-button--3_Z00";
export const arrowButtonGrey = "ArrowButton-module--arrow-button--grey--34PKs";
export const arrowButtonLarge = "ArrowButton-module--arrow-button--large--27z96";
export const arrowButton__background = "ArrowButton-module--arrow-button__background--2kvWf";
export const arrowButton__svg = "ArrowButton-module--arrow-button__svg--_m5Yf";
export const arrowButtonSmall = "ArrowButton-module--arrow-button--small--DcnfH";
export const arrowButtonBlue = "ArrowButton-module--arrow-button--blue--2tDOp";
export const arrowButton__svgSmall = "ArrowButton-module--arrow-button__svg--small--8QOQt";